import React from 'react';
import PropTypes from 'prop-types';
import { Button as AntButton } from 'antd';
import { useTheme } from '../../../contexts/ThemeContext';

export const Button = ({ children, type = 'default', style, disabled, ...props }) => {
  const { theme } = useTheme();

  const baseStyle = {
    transition: 'all 0.3s ease',
  };

  const typeStyles = {
    primary: {
      backgroundColor: theme.primary,
      color: theme.white,
      borderColor: theme.primary,
      '&:hover': {
        backgroundColor: theme.hoverPrimary,
        borderColor: theme.hoverPrimary,
        color: theme.white,
      },
      '&:disabled': {
        backgroundColor: theme.backgroundSecondary,
        borderColor: theme.border,
        color: theme.textTertiary,
      }
    },
    default: {
      backgroundColor: theme.white,
      color: theme.primary,
      borderColor: theme.primary,
      '&:hover': {
        backgroundColor: theme.backgroundSecondary,
        borderColor: theme.primary,
        color: theme.primary,
      },
      '&:disabled': {
        backgroundColor: theme.backgroundSecondary,
        borderColor: theme.border,
        color: theme.textTertiary,
      }
    },
  };

  const buttonStyle = {
    ...baseStyle,
    ...typeStyles[type],
    ...(disabled && {
      backgroundColor: theme.backgroundSecondary,
      borderColor: theme.border,
      color: theme.textTertiary,
    }),
    ...style,
  };

  return (
    <AntButton
      type={type}
      style={buttonStyle}
      disabled={disabled}
      {...props}
    >
      {children}
    </AntButton>
  );
};

Button.propTypes = {
  children: PropTypes.node.isRequired,
  type: PropTypes.oneOf(['primary', 'default', 'dashed', 'text', 'link']),
  style: PropTypes.object,
  disabled: PropTypes.bool,
};

export default Button; 